import { useQuery } from '@tanstack/react-query'
import { useLocation, useParams } from 'react-router-dom'
import Page from '../../components/layouts/page'
import List from '../../components/list'

// Identifier + more than two language columns is too tight at max-w-4xl.
const WIDE_ITEMS_LANGUAGE_THRESHOLD = 2

const ListPage = () => {
  const { airlineID, cycleID, listID } = useParams()
  const { pathname } = useLocation()
  const isDetailsTab = pathname.endsWith('/details')
  const isItemsTab = pathname.endsWith('/items')
  const { data: cycle, isLoading, error: cycleError } = useQuery(['cycles/', cycleID])
  const schemaId = cycle?.schema_id
  const {
    data: schema,
    isLoading: isSchemaLoading,
    error: schemaError,
  } = useQuery({
    queryKey: [`schemas/`, schemaId],
    enabled: !!schemaId,
  })
  const { data: collection, isLoading: isCollectionLoading } = useQuery(['collections/', listID])
  const needsWideItems = isItemsTab && Boolean(collection?.is_localizable) && Boolean(schema?.id)
  const { data: languages } = useQuery({
    queryKey: [`languages?airlineId=${airlineID ?? ''}&schemaId=${schema?.id ?? ''}`],
    enabled: needsWideItems,
  })
  const useNarrow =
    isDetailsTab ||
    (isItemsTab &&
      (!collection?.is_localizable || (languages != null && languages.length <= WIDE_ITEMS_LANGUAGE_THRESHOLD)))
  const root = `/airlines/${airlineID}/cycles/${cycleID}`

  return (
    <Page
      className={useNarrow ? 'cs-page-narrow' : undefined}
      pending={isLoading || isSchemaLoading || isCollectionLoading}
      error={cycleError || schemaError || !cycle || !schema || !collection}
      breadcrumbs={[{ text: 'Lists', to: `${root}/lists` }, { text: collection?.name }]}
      tabs={[
        { name: 'Details', to: 'details' },
        { name: 'Items', to: 'items' },
      ]}
    >
      {schema && collection ? (
        <List schema={schema} disabled={!collection?.user_permissions?.['can_edit_items']} />
      ) : null}
    </Page>
  )
}

export default ListPage
